import { useClickAndCollectLocationStore } from '../components/shoppingCart/stores/clickAndCollectLocationStore';
import { OrderType } from '../components/shoppingCart/stores/orderTypeStore.model';

/**
 * Resolves the warehouse code that inventory checks should be run against for
 * the given order type: `undefined` for Online (the default online
 * warehouse), or the resolved click & collect store's warehouse code for
 * "Klikk og hent" — loading the store list first if it hasn't been loaded yet.
 *
 * Shared by `useOrderTypeToggle` (order-type toggle re-fetch) and
 * `useStockValidation` (submit-time stock re-check), which both need the same
 * resolution.
 */
export async function resolveOrderTypeWarehouseCode(
  orderType: OrderType
): Promise<string | undefined> {
  if (orderType !== 'clickAndCollect') return undefined;

  const clickAndCollectLocationStore = useClickAndCollectLocationStore();
  if (!clickAndCollectLocationStore.isLoaded) {
    await clickAndCollectLocationStore.fetchStore();
  }
  return clickAndCollectLocationStore.warehouseCode;
}
